<template>
  <div class="ach-choice-dialog">
    <header class="ach-dialog-heading">
      <div>
        <span class="dialog-kicker">{{ $t('invoices.ach-account.new-account') }}</span>
        <h2>{{ $t('invoices.new-ach-account.connect-account') }}</h2>
      </div>
      <button type="button" class="dialog-close" :aria-label="$t('global.close')" @click="handleClose">
        <portal-icon name="x" :size="19"></portal-icon>
      </button>
    </header>

    <div class="connection-grid">
      <article class="connection-card recommended">
        <span class="connection-icon">
          <portal-icon name="landmark" :size="25"></portal-icon>
        </span>
        <div>
          <h3>{{ $t('invoices.new-ach-account.verification') }}</h3>
          <portal-status-pill background="var(--v-success_10-base)" color="var(--v-success-base)">
            <portal-icon name="check" :size="14"></portal-icon>
            {{ $t('invoices.new-ach-account.recommended') }}
          </portal-status-pill>
        </div>
        <p>{{ $t('invoices.new-ach-account.use-plaid') }}</p>
        <button type="button" class="connection-action primary" @click="connectPlaid">
          {{ $t('invoices.new-ach-account.connect-plaid') }}
          <portal-icon name="arrow-right" :size="17"></portal-icon>
        </button>
      </article>

      <article class="connection-card">
        <span class="connection-icon">
          <portal-icon name="receipt-text" :size="25"></portal-icon>
        </span>
        <div>
          <h3>{{ $t('invoices.new-ach-account.enter-info') }}</h3>
        </div>
        <p>{{ $t('invoices.new-ach-account.stripe-verification') }}</p>
        <button type="button" class="connection-action outline" @click="connectManually">
          {{ $t('invoices.new-ach-account.connect-manually') }}
          <portal-icon name="arrow-right" :size="17"></portal-icon>
        </button>
      </article>
    </div>
  </div>
</template>

<script>
import PortalIcon from '@/components/PortalIcon.vue';
import PortalStatusPill from '@/components/PortalStatusPill.vue';

export default {
  name: 'NewAchAccount',

  props: [],

  components: { PortalIcon, PortalStatusPill },

  data: function() {
    return {};
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {
    connectPlaid: function(){
      this.$emit('result','PLAID');
    },

    connectManually: function(){
      this.$emit('result','MANUAL');
    },

    handleClose() {
      this.$emit('result', false);
    },
  },

  computed: {},

};
</script>

<style scoped lang="scss">
  .ach-choice-dialog {
    width: min(760px, calc(100vw - 32px));
    max-height: calc(100vh - 32px);
    overflow: auto;
    border-radius: var(--brand-surface-radius, 18px);
    background: var(--portal-surface);
  }

  .ach-dialog-heading {
    min-height: 76px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
    padding: 16px 20px;
    border-bottom: 1px solid var(--portal-border);
    text-align: left;
  }

  .dialog-kicker {
    display: block;
    margin-bottom: 3px;
    color: var(--v-primary-base);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }

  .ach-dialog-heading h2,
  .connection-card h3 {
    margin: 0;
    color: var(--portal-text);
    font-weight: 650;
  }

  .ach-dialog-heading h2 {
    font-size: 18px;
  }

  .dialog-close {
    width: 38px;
    height: 38px;
    flex: 0 0 38px;
    display: grid;
    place-items: center;
    border: 0;
    border-radius: 11px;
    background: transparent;
    color: var(--portal-muted);
    cursor: pointer;
  }

  .dialog-close:hover {
    background: var(--v-gray_20-base);
    color: var(--portal-text);
  }

  .connection-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    padding: 20px;
  }

  .connection-card {
    min-width: 0;
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    align-content: start;
    gap: 14px 12px;
    padding: 18px;
    border: 1px solid var(--portal-border);
    border-radius: var(--brand-surface-radius, 15px);
    background: var(--portal-surface);
    text-align: left;
  }

  .connection-card.recommended {
    border-color: color-mix(in srgb, var(--v-primary-base) 32%, var(--portal-border));
    box-shadow: inset 3px 0 0 var(--v-primary-base);
  }

  .connection-icon {
    width: 44px;
    height: 44px;
    display: grid;
    place-items: center;
    border-radius: 12px;
    background: color-mix(in srgb, var(--v-primary-base) 9%, var(--portal-surface));
    color: var(--v-primary-base);
  }

  .connection-card h3 {
    margin: 2px 0 7px;
    font-size: 15px;
    line-height: 1.3;
  }

  .connection-card p {
    grid-column: 1 / -1;
    margin: 0;
    color: var(--portal-muted);
    font-size: 13px;
    line-height: 1.55;
  }

  .connection-action {
    grid-column: 1 / -1;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: auto;
    padding: 0 14px;
    border: 1px solid var(--portal-border);
    border-radius: var(--brand-button-radius, 11px);
    font: inherit;
    font-size: 13px;
    font-weight: 650;
    cursor: pointer;
  }

  .connection-action.primary {
    border-color: var(--v-primary-base);
    background: var(--v-primary-base);
    color: var(--v-white-base);
  }

  .connection-action.outline {
    background: var(--portal-surface);
    color: var(--portal-text);
  }

  @media (max-width: 679px) {
    .connection-grid {
      grid-template-columns: 1fr;
      padding: 14px;
    }
  }
</style>
